var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellphoneHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.284179 2.31445L0.28418 9.3457C0.28418 10.5088 1.23045 11.4551 2.39355 11.4551C2.97732 11.4551 15.6552 11.4551 16.1748 11.4551C17.3379 11.4551 18.2842 10.5088 18.2842 9.3457L18.2842 2.31445C18.2842 1.15134 17.3379 0.205077 16.1748 0.205077C15.8277 0.205077 2.76421 0.205078 2.39355 0.205078C1.23044 0.205078 0.284179 1.15134 0.284179 2.31445ZM16.1748 1.61133C16.5625 1.61133 16.8779 1.92675 16.8779 2.31445L16.8779 9.3457C16.8779 9.73341 16.5625 10.0488 16.1748 10.0488L13.6084 10.0488L13.6084 1.61133L16.1748 1.61133ZM12.2021 1.61133L12.2021 10.0488L4.3623 10.0488L4.3623 1.61133L12.2021 1.61133ZM2.95605 1.61133L2.95605 10.0488L2.39355 10.0488C2.00585 10.0488 1.69043 9.73341 1.69043 9.3457L1.69043 2.31445C1.69043 1.92675 2.00585 1.61133 2.39355 1.61133L2.95605 1.61133Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphoneHorizontal);
export default __webpack_public_path__ + "static/media/cellphone-horizontal.a81c505c1e357d87d7a2cb17366be589.svg";
export { ForwardRef as ReactComponent };